module.exports = __webpack_public_path__ + "static/media/GpsRouteIcon.b8be0bc2.svg";